module.exports = new __parcel__URL__("hp_icon_large.e62de31c.png").toString();